<!-- 急救实况的地图 -->
<template>
  <div>
    <div
      id="container"
      class="fullscreenMap"
      style="width:1272px;height:360px"
    />
    <div id="panel"/>
  </div>
</template>1

<script>
import AMap from "AMap";
import { mapState } from "vuex";
// import "@/assets/css/navigation.css";
import { getSCoordinate } from "@components/MapContainer/tools/tool";

export default {
  name: "CleanModeMap",
  data() {
    return {
      // centerMapPoint: [], // 地图中心点
      mapData: {}, // 所有的急救车经纬度地址
      timers: [], // 计时器们
      firstMessageCars: {},
      lastList: {},
      destinations: {}, // 导航的目的地,急救车编号对应的地址 会根据阶段不同进行改变
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      hospitalInfo: "hospitalInfo",
      carObject: "carObject",
      currentList: "currentList",
      allPosition: "allPosition"
    }),
    realAmbulanceList() {
      return this.ambulanceLists.filter(car => {
        return car.type === "急救车";
      });
    },
  },
  watch: {
    currentList: {
      handler(val) {
        // 简单的处理, 当有任务被结束, 新增等行为的时候, 重绘地图规划
        this.dealInitDriving(val);
      }
    },
    // 不断的更新所有车辆的GPS定位数据 (include a key "-1" for update)
    allPosition: {
      handler(val) {
        console.log("update all the car's gps data!");
        this.getMessage(val);
      }
    }
  },
  beforeUnmount() {
    this.timers.forEach(timer => {
      clearInterval(timer);
      timer = null;
    });
    this.map?.destroy();
    this.map = null;
    this.driving = null;
  },
  mounted() {
    this.realAmbulanceList.forEach(e => {
      this.firstMessageCars[e.id] = true;
    });
    this.map = null; // 高德地图map对象
    this.driving = null;
    this.initMap();
    this.dealInitDriving(this.currentList);
  },

  methods: {
    dealInitDriving(val) {
      if (this.driving) {
        if (this.lastList === JSON.stringify(val)) {
          // 跟上次一模一样的话, 什么都不做处理
        } else {
          // 内容有变动, 需要重新规划...
          // 2秒后重新规划 (防止数据没有更新上)
          setTimeout(() => {
            console.log("清空规划...");
            // 并不是有GPS就规划路线, 必须得是有任务
            this.realAmbulanceList.forEach(e => {
              this.firstMessageCars[e.id] = true;
            });
            this.map = null; // 高德地图map对象
            this.driving.clear();
            this.driving = null;
            this.timers.forEach(timer => {
              clearInterval(timer);
              timer = null;
            });
            // 摧毁重新渲染的代价有点大, 但是也是不可避免的
            this.initMap();
          }, 1000 * 2);
        }
        this.lastList = JSON.stringify(val);
      }
    },
    getMessage(carPositions) {
      delete carPositions[-1];
      Object.keys(carPositions).forEach(async (car_id) => {
        let dataJson;
        try {
          dataJson = JSON.parse(carPositions[car_id]);
        } catch (e) {
          dataJson = carPositions[car_id];
        }
        console.log(`Get GPS message, ${dataJson}`);
        this.mapData[car_id] = dataJson;
        const current = this.currentList.find(({ ambulanceId }) => {
          return ambulanceId === car_id * 1;
        });
        // 首先, 必须是第一次渲染, 有终点, 其次必须该车有任务
        const isShowDriving = this.firstMessageCars[car_id] && current;
        // console.log(this.firstMessageCars, dataJson);
        if (isShowDriving) {
          const { statu, patientAddr, longitude, latitude } = current;
          const status = statu * 1;
          const { targetLocation: hospitalAddress } = getSCoordinate(this.realAmbulanceList, car_id);
          if (status >= 3) { // 患者已经上车, 定位前往医院
            console.log("状态为3, 回医院, 地址是: " + hospitalAddress);
            const { longitude, latitude } = this.hospitalInfo;
            this.destinations[car_id] = [longitude, latitude];
            // this.destinations[car_id] = await addressTolongLati(hospitalAddress, [dataJson.longitude, dataJson.dimension]);
          } else { // 患者未上车, 定位前往患者所在地
            console.log("状态小于3, 去患者那边, 地址是: " + patientAddr);
            this.destinations[car_id] = [longitude, latitude];
            // this.destinations[car_id] = await addressTolongLati(patientAddr, [dataJson.longitude, dataJson.dimension]);
          }
          this.firstMessageCars[car_id] = false;
          this.beginDriving(car_id, dataJson);
        }
      });
    },
    initMap() {
      // 获得医院地址作为中心点
      const { longitude, latitude } = this.hospitalInfo;
      // this.centerMapPoint = [longitude, latitude];
      this.map = new AMap.Map("container", {
        center: [longitude, latitude],
        resizeEnable: true,
        viewMode: "2D", // 设置地图模式
        lang: "zh_cn", // 设置地图语言类型
        zoom: 13,
      });

      const ambulanceIcon = new AMap.Icon({
        size: new AMap.Size(50, 32),
        image: require("@/assets/icons/hospital.png"),
        imageSize: new AMap.Size(32, 32),
      });

      const ambulanceMarker = new AMap.Marker({
        position: [longitude, latitude], // 急救车图标安排上
        icon: ambulanceIcon,
        offset: new AMap.Pixel(0, 0),
      });
      this.map.add(ambulanceMarker);

      this.driving = new AMap.Driving({
        map: this.map,
      });

      // 每一辆 放置急救车图标
      this.realAmbulanceList.forEach(async car => {
        const { longitude, latitude, id } = car;
        const icon = new AMap.Icon({
          size: new AMap.Size(50, 32),
          image: require("@/assets/photos/working.png"),
          imageSize: new AMap.Size(50, 32),
        });
        const ambulanceMarker = new AMap.Marker({
          position: new AMap.LngLat(longitude, latitude),
          icon: icon,
          offset: new AMap.Pixel(0, 0),
        });

        this.map.add(ambulanceMarker);
        const timer = setInterval(() => {
          //  循环更新GPS定位
          if (this.mapData[id]) {
            const long = this.mapData[id]["longitude"];
            const lan = this.mapData[id]["dimension"];
            if (long && lan) {
              ambulanceMarker.setPosition([long, lan]);
            }
          }
        }, 1000);
        this.timers.push(timer);
        // }
      });
    },
    // 开始规划导航, 目的地有2种.
    // 在患者上车之前, 导航目的地是患者的地址
    // 患者上车后, 导航的目的地是医院
    beginDriving(car_id, message) {
      const carTimeList = [];
      console.log(`开始规划${car_id - 1}号急救车路线, 起点是: ${message.longitude}, ${message.dimension}`);
      console.log(`开始规划${car_id - 1}号急救车路线, 终点是: ${this.destinations[car_id]}`);
      this.driving.search(
        // 每一辆急救车, 默认携带的地址
        new AMap.LngLat(message.longitude, message.dimension),
        this.destinations[car_id],
        async (status, result) => {
          if (!result?.routes?.length) {
            return;
          }
          const cost_time = await result?.routes[0]?.time || 0;
          const carList = {
            id: message.id,
            name: this.carObject[message.car_id],
            time: Math.round(cost_time / 60),
          };
          carTimeList.push(carList);
        }
      );
      this.$emit("getLeftTime", carTimeList);
    }
  },

};
</script>
<style scoped>
.fullscreenMap {
  height: 530px !important;
  margin-left: 10px;
  width: 960px !important;
}

.amap-container {
  height: 360px;
  width: 1270px;
}
</style>
